import React from "react";
import SEO from "../components/seo";
import SiteLayout from "../components/site/SiteLayout";
import EditLink from "../components/site/EditLink";
import RichText, { MultilineText } from "../components/site/RichText";
import { useSobre } from "../lib/institucional";

export default function Institucional() {
  const page = useSobre();

  const pilares = [
    { label: page.labelProposito, texto: page.proposito },
    { label: page.labelMissao, texto: page.missao },
    { label: page.labelVisao, texto: page.visao },
  ].filter((pilar) => pilar.texto);

  return (
    <SiteLayout>
      <SEO
        lang="pt-BR"
        keywords={[`Bivver`, `Institucional`, `Quem Somos`, `incorporadora`]}
        description="Conheça o propósito, a missão, a visão e os valores da Bivver Empreendimentos Imobiliários no litoral norte catarinense."
        title="Quem Somos — Bivver Empreendimentos"
      />

      <EditLink to="/edicao/sobre" />

      <section className="institutional-page">
        <span className="institutional-eyebrow">{page.eyebrow}</span>
        <h1 className="institutional-title">{page.tituloPagina}</h1>

        <div className="institutional-intro">
          <RichText source={page.quemSomos} />
        </div>

        {page.destaque && (
          <blockquote className="institutional-highlight">
            <MultilineText text={page.destaque} />
          </blockquote>
        )}

        <div className="pillars-grid">
          {pilares.map((pilar) => (
            <div className="pillar-card" key={pilar.label}>
              <span className="pillar-label">{pilar.label}</span>
              <RichText source={pilar.texto} />
            </div>
          ))}
        </div>

        <h2 className="institutional-subtitle">{page.tituloValores}</h2>
        <div className="values-grid">
          {page.valoresLista.map((valor) => (
            <div className="value-card" key={valor.id || valor.titulo}>
              <h3 className="value-card-title">{valor.titulo}</h3>
              <p className="value-card-text">{valor.texto}</p>
            </div>
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}
